import { Fragment } from "react"

/**
 * A ref in the mono face with every letter O drawn in the sans face (decision 0159): in IBM Plex Mono at 12 px "O-4"
 * reads as "0-4". Digits and every other letter stay mono, so the ref keeps its width and look; copy and search see the
 * same text (only the glyph's font changes).
 */
export function MonoRef({ text }: { text: string }) {
  if (!text.includes("O")) return <>{text}</>
  const parts = text.split("O")
  return (
    <>
      {parts.map((p, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: pieces of one string, in order
        <Fragment key={i}>
          {i > 0 && (
            <span data-letter-o="" className="font-sans">
              O
            </span>
          )}
          {p}
        </Fragment>
      ))}
    </>
  )
}
